export const css = {
	root: '_6XVJvrz_',
	slideIn: '_3W1f2UEG',
	slideOut: 'vGpaOl_J',
	underlayVisible: '_3509hpvU',
	content: 'lqx4pXnA',
	pane: 'iuHkSPuE',
	title: '_3MEcTyuL',
	titleContent: '_1EBbuG3I',
	close: '_2IYWoXcN',
	closeIcon: '_2GtMvucU',
	left: '_29BU1zWK',
	right: 'K1tLEdYK',
	top: 'RgEIML4q',
	bottom: 'kQgzHLjy',
	open: '_2Abj1Ssl',
	' _key': 'ascm-theme/ascm/base-widgets/sliding-pane'
};

export default css;
